<template>
  <b-modal
    v-model="show"
    id="announcement-popup"
    :title="$t('dashboard-announcements.title-popup')"
    size="xl"
    centered
    scrollable
    header-bg-variant="primary"
    header-text-variant="white"
    no-close-on-backdrop
  >
    <div v-if="loading" class="text-center p-5">
      <b-spinner variant="primary"></b-spinner>
    </div>

    <div v-else-if="announcements.length === 0" class="text-center p-5 text-muted">
      {{ $t('dashboard-announcements.message-no-unread') }}
    </div>

    <div v-else class="list-group list-group-flush">
      <div
        v-for="item in announcements"
        :key="item.id"
        v-b-toggle="`accordion-${item.id}`"
        class="list-group-item list-group-item-action border-left-0 border-right-0 px-4 py-4"
        role="button"
      >
        <div class="d-flex justify-content-between align-items-start">
          <h4 class="mb-1 font-weight-bold">{{ item.title }}</h4>
          <i class="fas fa-chevron-down ml-3 mt-1 text-primary chevron-icon"></i>
        </div>
        <span class="text-muted">{{ formatDate(item.created_at) }}</span>

        <b-collapse :id="`accordion-${item.id}`" accordion="announcement-accordion" class="mt-3">
          <p class="mb-3 white-space-pre-wrap text-dark lead">{{ item.body }}</p>
          <b-button
            v-if="item.attachment_url"
            :href="item.attachment_url"
            target="_blank"
            variant="outline-info"
            size="sm"
            @click.stop
          >
            <i class="fas fa-paperclip mr-1"></i> {{ $t('dashboard-announcements.button-download') }}
          </b-button>
        </b-collapse>
      </div>
    </div>

    <template #modal-footer>
      <div class="w-100 d-flex justify-content-end">
        <b-button variant="primary" class="btn-confirm" @click="markAllAsRead">
          {{ $t('dashboard-announcements.button-mark-all-read') }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import announcementApi from "@/api/announcements";
import moment from "moment";

export default {
  name: "AnnouncementPopup",
  data() {
    return {
      show: false,
      loading: false,
      announcements: []
    };
  },
  methods: {
    async fetchUnread() {
      try {
        this.loading = true;
        const response = await announcementApi.getUnreadAnnouncements();
        this.announcements = response.data.announcements;
        
        if (this.announcements.length > 0) {
          this.show = true;
        }
      } catch (error) {
        console.error("Failed to fetch announcements:", error);
      } finally {
        this.loading = false;
      }
    },
    async markAllAsRead() {
      const ids = this.announcements.map(a => a.id);
      if (ids.length === 0) return;

      try {
        await announcementApi.readAnnouncements(ids);
        this.show = false;
        this.announcements = [];
        // 「全て既読」した後、未読バッジをサーバー値と整合させる。
        // 強制的に 0 をセットすると、ポップアップ表示中に新規投稿された
        // お知らせや、並列で in-flight な fetchUnreadAnnouncementCount の
        // 旧レスポンスとの競合でバッジが狂う可能性があるため、必ず再フェッチする。
        this.$store.dispatch("dashboard/fetchUnreadAnnouncementCount");
      } catch (error) {
        console.error("Failed to mark announcements as read:", error);
      }
    },
    formatDate(date) {
      return moment(date).format("YYYY/MM/DD HH:mm");
    }
  },
  mounted() {
    // ログイン直後のみ未読お知らせを取得して popup 表示する。
    // フラグはログイン成功時 (pages/auth/login/login.vue) で立てる。
    // ブックマーク直アクセス・リロード・画面遷移では表示しない。
    if (sessionStorage.getItem("announcement_popup_pending") !== "1") return;
    sessionStorage.removeItem("announcement_popup_pending");
    this.fetchUnread();
  }
};
</script>

<style scoped>
.chevron-icon {
  transition: transform 0.3s ease;
}
.not-collapsed .chevron-icon {
  transform: rotate(180deg);
}
.white-space-pre-wrap {
  white-space: pre-wrap;
}
.btn-confirm {
  min-width: 200px;
}
</style>
